import {Component, Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class LoanOdAccountsPopupComponent {
    private isOpen = false;

    constructor(private modalService: NgbModal,
                private router: Router) {
    }

    open(component: Component, message?: String | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
    }

    errorMessageFortransaction(component: Component): NgbModalRef {
        const modalRef = this.modalService.open(component, {size: 'lg', backdrop: 'static'});
        modalRef.result.then((result) => {
            this.router.navigate([{outlets: {popup: null}}], {replaceUrl: true});
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{outlets: {popup: null}}], {replaceUrl: true});
            this.isOpen = false;
        });
        return modalRef;
    }
}
